<template>
  <div v-if="coverData !== null">
    <header class="header">
      <h1>
        <a href="#">
          <Logo/>
        </a>
      </h1>
      <a href="#" @click.prevent="login" class="link-login">로그인</a>
    </header>

    <main class="main">
      <!-- 첫 번째 영역 -->
      <section id="section1" class="section" ref="section1">
        <div class="title-area">
          <h2 class="title" v-html="section1MainText"></h2>
          <h3 class="sub-title" v-html="section1SubText"></h3>
          <a href="#" @click.prevent="memberJoin" class="btn btn-primary btn-animation">{{button1Text}}</a>
        </div>

        <div class="content-area">
          <div id="fluidSwiper" class="swiper-container" ref="fluidSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(imageUrl, index) in section1ImageList" :key="'section_1_' + index">
                <img :src="imageUrl" :alt="'@배너 샘플 ' + index ">
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- /첫 번째 영역 -->

      <!-- 두 번째 영역 -->
      <section id="section2" class="section" ref="section2">
        <div class="title-area">
          <h2 class="title" v-html="section2MainText"></h2>
          <h3 class="sub-title" v-html="section2SubText"></h3>
        </div>

        <div class="content-area">
          <div class="coupon">
            <img :src="section2ImageUrl" alt="이벤트 첫 달 100원 쿠폰" @error="getSection2ImageDefault">
          </div>
          <div class="notice">
            <span v-html="section2BottomText"></span>
          </div>
        </div>
      </section>
      <!-- /두 번째 영역 -->

      <!-- 세 번째 영역 -->
      <section id="section3" class="section" ref="section3">
        <div class="title-area">
          <h2 class="title" v-html="section3MainText"></h2>
          <h3 class="sub-title" v-html="section3SubText"></h3>
        </div>
        <div class="content-area">
          <div id="fadeSwiper" class="swiper-container" ref="fadeSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="({poster_image_url = ''}, index) in section3ContentInfoList" :key="'section_3_' + index">
                <div class="content-image">
                  <img :src="poster_image_url" alt="@배너 샘플 7">
                </div>
              </div>
            </div>
          </div>

          <div id="textFadeSwiper" class="swiper-container" ref="textFadeSwiper">
            <div class="swiper-wrapper">
              <div
                  class="swiper-slide"
                  v-for="({genre_text = '', content_type = '', detail_text = {}}, index) in section3ContentInfoList"
                  :key="'section_3_1_' + index"
              >
                <div class="content-text">
                  <h4 class="content-title">{{ getContentTitle(content_type, detail_text) }}</h4>
                  <div class="content-metadata">
                    <span>{{ setContentMetaDataType(content_type, detail_text) }}</span>
                    <span class="icon-dotted"></span>
                    <span>{{detail_text.genretext}}</span>
                    <span class="icon-dotted"></span>
                    <span>{{detail_text.playtimetext}}</span>
                    <span class="icon-dotted"></span>
                    <span>{{detail_text.targetage}}세</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </section>
      <!-- /세 번째 영역 -->

      <!-- 네 번째 영역 -->
      <section id="section4" class="section" ref="section4">
        <div class="title-area">
          <h2 class="title" v-html="section4MainText"></h2>
          <h3 class="sub-title" v-html="section4SubText"></h3>
        </div>

        <div class="content-area">
          <div class="quick-vod-area">
            <div class="timer">
              <ClockIcon alt="시계 아이콘" class="timer-icon"/>
              <div class="timer-frame">
                <ol>
                  <li>1</li>
                  <li>2</li>
                  <li>3</li>
                  <li>4</li>
                  <li>5</li>
                </ol>
              </div>
              <span>Min</span>
            </div>
            <div class="device">
              <div class="viewport">
                <img :src="section4ImageUrl" class="screen" alt="Quick VOD 이미지">
                <!-- 플레이어 영역 -->
              </div>
              <span class="tag-quick-vod">
                <img src="./assets/images/icon-tag-defaul-ic-tagcode-quickvod@3x.png" alt="Quick VOD 태그">
              </span>
            </div>
          </div>
          <a href="#" @click.prevent="moveToPrivacy" class="link-privacy">
            <span>개인정보 처리방침</span>
          </a>
        </div>
      </section>
      <!-- /네 번째 영역 -->
    </main>
    <a href="#" @click.prevent="memberJoin" class="btn btn-primary btn-floating" ref="float_btn">{{button2Text}}</a>
  </div>
</template>
<script>
import { get, throttle } from 'lodash'
import { getCoverMetaData } from '@/common/api/api.service'
import scrollMonitor from 'scrollmonitor'
import Logo from '@/assets/svg/logo/logo.svg'
import ClockIcon from '@/views/cover/assets/images/04-quick-vod-ic-clock.svg'
import utils from '@/common/util/utils'
import { isApp } from '@/common/util/common'
require('./assets/js/swiper-bundle')
const SECTION_2_PROMOTION_DEFAULT_IMAGE_URL = require('./assets/images/02-promotion-img-coupon-tablet@3x.png')
const SECTION_4_QVOD_DEFAULT_IMAGE_URL = 'https://img.wavve.com/service/coverpage/tracer_0218.jpg'

export default {
  componentName: 'CoverPage',
  components: {
    Logo,
    ClockIcon
  },
  data () {
    return {
      coverData: null,
      fluidSwiper: null,
      textFadeSwiper: null,
      fadeSwiper: null
    }
  },
  methods: {
    login () {
      if (isApp()) {
        location.href = 'captvpooq://member/login'
      } else {
        this.$router.push('/login')
      }
    },
    memberJoin () {
      location.href = isApp() ? 'captvpooq://member/signup' : 'https://member.wavve.com/mobile/signup?device=mobile'
    },
    bottomButtonScrollEvent: throttle(function () {
      const { y: section2Y } = this.$refs['section2'].getBoundingClientRect()
      const { bottom: section4Bottom } = this.$refs['section4'].getBoundingClientRect()
      const btnEl = this.$refs['float_btn']
      if (section2Y < (window.innerHeight / 2) - 100) {
        btnEl.classList && btnEl.classList.add('on')
      } else {
        btnEl.classList && btnEl.classList.remove('on')
      }
      if (section4Bottom < window.innerHeight) {
        const section4El = this.$refs['section4']
        section4El && section4El.classList.add('on')
      }
    }, 180),
    setCoverMetaData () {
      getCoverMetaData().then(({ data }) => {
        this.coverData = get(data, 'cover_page', null)
      }).then(() => {
        this.$nextTick(() => this.initSwipers())
        this.$nextTick(() => {
          const attachScrollEventEL = ({ targetEl, payloadHeight, enterFn, leaveFn }) => {
            const monitorInstance = scrollMonitor.create(targetEl, payloadHeight)
            if (typeof enterFn === 'function') monitorInstance.enterViewport(() => enterFn(targetEl))
            if (typeof leaveFn === 'function') monitorInstance.exitViewport(() => leaveFn(targetEl))
          }
          ['section1', 'section2', 'section3', 'section4'].map((refName) => {
            attachScrollEventEL({
              targetEl: this.$refs[refName],
              payloadHeight: { top: -(window.innerHeight / 2) },
              enterFn: (el) => {
                el && el.classList && el.classList.add('on')
              }
            })
          })
        })
        window.addEventListener('scroll', this.bottomButtonScrollEvent)
      })
    },
    initSwipers () {
      // eslint-disable-next-line no-undef
      this.fluidSwiper = new Swiper(this.$refs['fluidSwiper'], {
        loop: true,
        speed: 5000,
        allowTouchMove: false,
        autoplay: {
          delay: 10,
          disableOnInteraction: false
        },
        breakpoints: {
          320: {
            slidesPerView: 2.5,
            spaceBetween: 32
          },
          768: {
            slidesPerView: 4.5,
            spaceBetween: 59
          }
        }
      })
      // eslint-disable-next-line no-undef
      this.textFadeSwiper = new Swiper(this.$refs['textFadeSwiper'], {
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        loopedSlides: 4,
        speed: 1000,
        autoplay: {
          delay: 2000
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          renderBullet: (index, className) => {
            return `<span class="${className}">${this.section3ContentInfoList[index].genre_text}</span>`
          }
        }
      })
      // eslint-disable-next-line no-undef
      this.fadeSwiper = new Swiper(this.$refs['fadeSwiper'], {
        loop: true,
        freeMode: true,
        centeredSlides: true,
        allowTouchMove: false,
        loopedSlides: 4,
        speed: 1000,
        autoplay: {
          delay: 2000
        },
        thumbs: {
          swiper: this.textFadeSwiper
        },
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 3.3,
            spaceBetween: 21
          }
        }
      })
    },
    getContentTitle (contentType, { title, programtitle }) {
      const IS_CONTENT_MOVIE = contentType.toLowerCase() === 'movie'
      return IS_CONTENT_MOVIE ? title : programtitle
    },
    setContentMetaDataType (contentType, { rating, episodenumber }) {
      const IS_MOVIE_METADATA_TYPE = contentType.toLowerCase() === 'movie'
      const mateDataRating = rating || 0
      const metaDataEpisodeNumber = episodenumber || 0
      return IS_MOVIE_METADATA_TYPE ? `평점 ${mateDataRating}` : `${metaDataEpisodeNumber}회`
    },
    getSection2ImageDefault (event) {
      event.target.onerror = null
      event.target.src = SECTION_2_PROMOTION_DEFAULT_IMAGE_URL
    },
    moveToPrivacy () {
      if (isApp()) {
        location.href = 'captvpooq://customer/agreement?category=privacy'
      } else {
        this.$router.push('/agreement/privacy?referer=/cover')
      }
    }
  },
  computed: {
    button1Text () {
      return get(this.coverData, 'button1_text', '')
    },
    button2Text () {
      return get(this.coverData, 'button2_text', '')
    },
    section1MainText () {
      return (get(this.coverData, 'div1_main_text', '') || '전-부\\n웨이브에 있었어!').replace(/\\n/g, '<br />')
    },
    section1SubText () {
      return (get(this.coverData, 'div1_sub_text', '') || '매일 100여 편씩 업데이트\\n국내 최다 콘텐츠').replace(/\\n/g, '<br />')
    },
    section1ImageList () {
      return get(this.coverData, 'div1_images_url', [])
    },
    section2MainText () {
      return (get(this.coverData, 'div2_main_text', '') || '신규 회원은\\n첫 달 100원').replace(/\\n/g, '<br />')
    },
    section2SubText () {
      return (get(this.coverData, 'div2_sub_text', '') || '가입 후 단 7일 간 2개월 50% 추가 할인!').replace(/\\n/g, '<br />')
    },
    section2ImageUrl () {
      return get(this.coverData, 'div2_Image_url', '')
    },
    section2BottomText () {
      return (get(this.coverData, 'div2_bottom_text', '') || '본 프로모션은 Google Play 결제 시 적용되지 않으며 \\nPC, 모바일웹 결제 시 적용됩니다.').replace(/\\n/g, '<br />')
    },
    section3MainText () {
      return (get(this.coverData, 'div3_main_text', '') || '국내, 해외시리즈\\n웨이브에 있었어!').replace(/\\n/g, '<br />')
    },
    section3SubText () {
      return (get(this.coverData, 'div3_sub_text', '') || '화제의 드라마부터\\n웨이브 오리지널, HBO시리즈까지').replace(/\\n/g, '<br />')
    },
    section3ContentInfoList () {
      return get(this.coverData, 'div3_contents_define', []).sort((a, b) => a.order_no - b.order_no)
    },
    section4MainText () {
      return (get(this.coverData, 'div4_main_text', '') || '세상에서 가장 빠른\\n다시보기').replace(/\\n/g, '<br />')
    },
    section4SubText () {
      return (get(this.coverData, 'div4_sub_text', '') || 'Quick VOD로 본방 시작 5분 만에\\n내 시간에 맞춰 On-Air').replace(/\\n/g, '<br />')
    },
    section4ImageUrl () {
      return get(this.coverData, 'div4_image_url', '') || SECTION_4_QVOD_DEFAULT_IMAGE_URL
    }

  },
  created () {
    if (utils.cookies.getCredential() !== 'none') {
      this.$router.replace('/')
    }
    this.setCoverMetaData()
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.bottomButtonScrollEvent)
  }
}

</script>
<style>
/* reset */
img{
  max-width: 100%;
}

/* common */
#app{
  padding-bottom: 72px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 72px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 72px);
}

html,
body{
  min-width: 320px;
  overflow-x: hidden;
  background-color: #101010 !important;
}

.btn{
  display: inline-block;
  height: 48px;
  padding: 0 20px;
  font-size: 14px;
  line-height: 46px;
  color: #fff;
  text-align: center;
}

.btn-primary{
  border: 1px #1351f9 solid;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  background-color: #1351f9;
}

.btn-floating{
  position: fixed;
  bottom: 0;
  left: 16px;
  right: 16px;
  z-index: 10;
  padding-bottom: calc(constant(safe-area-inset-bottom));
  padding-bottom: calc(env(safe-area-inset-bottom));
  opacity: 0;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
}

.btn-floating.on{
  bottom: 24px;
  opacity: 1;
}

.title,
.sub-title{
  color: #fff;
}

.title{
  font-size: 32px;
  line-height: 44px;
}

.sub-title{
  font-size: 16px;
  line-height: 24px;
}

.sub-title span{
  display: block;
}

.notice{
  padding: 0 50px;
  opacity: 0;
}

.notice span{
  position: relative;
  padding-left: 6px;
  font-size: 12px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.7);
}

.notice span::before{
  content: '';
  display: inline-block;
  position: absolute;
  top: 9px;
  left: 0;
  width: 1px;
  height: 1px;
  border: 1px rgba(255, 255, 255, 0.7) solid;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.7);
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* header */
.header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 11px 16px;
  background-color: rgba(16, 16, 16, 0.9);
  font-size: 0;
}

.header h1{
  display: inline-block;
  padding: 7px 0;
}

.header .link-login{
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  padding: 0 16px;
  font-size: 14px;
  line-height: 56px;
  color: #fff;
}

/* main */
.main{
  text-align: center;
}

/* section */
.section{
  padding: 50px 0;
}

.section:last-child{
  padding-bottom: 0;
}

.title + .sub-title{
  margin-top: 20px;
}

.sub-title + .btn{
  margin: 40px 0;
}

/* section1 */
#section1{
  padding-top: 96px;
}

#section1 #fluidSwiper {
  opacity: 0;
}

#fluidSwiper .swiper-wrapper {
  -webkit-transition-timing-function: linear !important;
  -moz-transition-timing-function: linear !important;
  -o-transition-timing-function: linear !important;
  transition-timing-function: linear !important;
}

#section1.on #fluidSwiper {
  transition-property: opacity;
  transition-duration: 1.5s;
  transition-delay: 1.5s;
  opacity: 1;
}

#section1 .swiper-slide:nth-child(6n-4){
  margin-top: 120px;
}

#section1 .swiper-slide:nth-child(6n-3){
  margin-top: 40px;
}

#section1 .swiper-slide:nth-child(6n-2){
  margin-top: 90px;
}

#section1 .swiper-slide:nth-child(6n-1){
  margin-top: 30px;
}

#section1 .swiper-slide:nth-child(6n){
  margin-top: 70px;
}

/* section2 */
#section2{
  padding: 50px 0 40px;
}

.coupon{
  position: relative;
  top: 10px;
  width: 280px;
  margin: 20px auto 0;
  padding: 20px 29px 20px;
  opacity: 0;
}

.coupon::after{
  content: '';
  display: block;
  height: 8px;
  margin-top: 10px;
  background-image: linear-gradient(to right, rgba(16, 16, 16, 0) 0%, #303030 51%, rgba(16, 16, 16, 0) 100%)
}

.coupon img{
  position: relative;
  z-index: 1;
}

.coupon + .notice{
  margin-top: 20px;
}

/* section3 */
#section3 .content-area{
  background-image: url(./assets/images/03-contents-img-device@3x.png);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 64% auto;
  opacity: 0;
  -webkit-transition: opacity 1.5s ease-in-out 0.5s;
  -moz-transition: opacity 1.5s ease-in-out 0.5s;
  -o-transition: opacity 1.5s ease-in-out 0.5s;
  transition: opacity 1.5s ease-in-out 0.5s;
}

#fadeSwiper{
  margin-top: 64px;
  padding-top: 30px;
}

#fadeSwiper .swiper-wrapper{
  -webkit-transition-timing-function: ease-in-out !important;
  -moz-transition-timing-function: ease-in-out !important;
  -o-transition-timing-function: ease-in-out !important;
  transition-timing-function: ease-in-out !important;
}

#fadeSwiper .swiper-slide .content-image{
  position: relative;
}

#fadeSwiper .swiper-slide .content-image::before{
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-transition: background-color 0.5s ease-in-out;
  -moz-transition: background-color 0.5s ease-in-out;
  -o-transition: background-color 0.5s ease-in-out;
  transition: background-color 0.5s ease-in-out;
}

#fadeSwiper .swiper-slide-active .content-image::before{
  background-color: rgba(0, 0, 0, 0);
}

#textFadeSwiper .swiper-slide .content-text{
  opacity: 0;
  -webkit-transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -o-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
}

#textFadeSwiper .swiper-slide.swiper-slide-thumb-active .content-text{
  opacity: 1;
  -webkit-transition: opacity 1.5s ease-in-out;
  -moz-transition: opacity 1.5s ease-in-out;
  -o-transition: opacity 1.5s ease-in-out;
  transition: opacity 1.5s ease-in-out;
}

/** 시작 **/
#textFadeSwiper .swiper-pagination.swiper-pagination-bullets{
  position: static;
  width: 60%;
  margin: 56px auto 0;
  font-size: 0;
}

#textFadeSwiper .swiper-pagination-bullet{
  width: auto;
  height: auto;
  padding: 4px 0;
  margin: 0 6px;
  border-bottom: 2px transparent solid;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  background-color: transparent;
  color: #717171;
  font-size: 16px;
  line-height: 24px;
  opacity: 1;
}
#textFadeSwiper .swiper-pagination-bullet.swiper-pagination-bullet-active{
  border-bottom: 3px solid #fff;
  color: #fff;
}
.content-text{
  width: 60%;
  margin: 0 auto;
  padding: 12px 28px 0;
  font-size: 0;
  text-align: left;
}

.content-title{
  position: relative;
  padding-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  line-height: 18px;
  color: #fff;
}

.content-title::after{
  content: '';
  position: absolute;
  top: 6px;
  right: 0;
  width: 0;
  height: 0;
  border-top: 5px #a5a5a5 solid;
  border-bottom: 8px transparent solid;
  border-right: 4px transparent solid;
  border-left: 4px transparent solid;
}

.content-metadata{
  font-size: 10px;
  line-height: 12px;
  color: #a5a5a5;
}

.content-title + .content-metadata{
  margin-top: 4px;
}

.content-metadata span{
  display: inline-block;
  vertical-align: middle;
}

.content-metadata .icon-dotted{
  margin: 0 4px;
  border: 1px #a5a5a5 solid;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

/* section4 */
.quick-vod-area{
  height: 228px;
  margin-top: 40px;
  background: url(./assets/images/04-quick-vod-background@3x.png) repeat-x center/contain;
}

.timer{
  height: 24px;
  overflow: hidden;
  font-size: 0;
  text-align: center;
  opacity: 1;
  -webkit-transition: opacity 0.5s ease-in-out 4.5s, height 1s ease-in-out 4.5s;
  -moz-transition: opacity 0.5s ease-in-out 4.5s, height 1s ease-in-out 4.5s;
  -o-transition: opacity 0.5s ease-in-out 4.5s, height 1s ease-in-out 4.5s;
  transition: opacity 0.5s ease-in-out 4.5s, height 1s ease-in-out 4.5s;
}

.section.on .timer{
  height: 0;
  opacity: 0;
}

.timer img,
.timer div,
.timer .timer-icon,
.timer span{
  display: inline-block;
  vertical-align: middle;
}

.timer img{
  width: 24px;
  height: 24px;
}

.timer .timer-frame{
  overflow: hidden;
  height: 24px;
  margin-left: 8px;
}

.timer ol,
.timer span{
  font-size: 16px;
  line-height: 24px;
  color: #fff;
}

.timer ol{
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column-reverse;
  -moz-flex-direction: column-reverse;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  position: relative;
  top: -400%;
}

.device{
  position: relative;
  width: 300px;
  height: 184px;
  margin: 20px auto 0;
  background-image: url(./assets/images/04-quick-vod-img-tv@3x.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  -webkit-transition: all 1s ease-in-out 4.5s;
  -moz-transition: all 1s ease-in-out 4.5s;
  -o-transition: all 1s ease-in-out 4.5s;
  transition: all 1s ease-in-out 4.5s;
}

.section.on .device{
  width: 258px;
  height: 144px;
  background-image: url(./assets/images/04-quick-vod-img-phone@3x.png);
}

.viewport{
  position: absolute;
  top: 4px;
  right: 4px;
  bottom: 20px;
  left: 4px;
  border-radius: 0;
  overflow: hidden;
  -webkit-transition: bottom 1s ease-in-out 4.5s, border-radius 1s ease-in-out 4.5s;
  -moz-transition: bottom 1s ease-in-out 4.5s, border-radius 1s ease-in-out 4.5s;
  -o-transition: bottom 1s ease-in-out 4.5s, border-radius 1s ease-in-out 4.5s;
  transition: bottom 1s ease-in-out 4.5s, border-radius 1s ease-in-out 4.5s;
}

.section.on .viewport{
  bottom: 4px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.viewport img.screen {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  max-width: unset;
  max-height: 100%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.device .tag-quick-vod{
  position: absolute;
  top: 12px;
  left: -40px;
  width: 100px;
  height: 29px;
  opacity: 0;
  -webkit-transition: all 1s ease 5.5s;
  -moz-transition: all 1s ease 5.5s;
  -o-transition: all 1s ease 5.5s;
  transition: all 1s ease 5.5s;
}

.section.on .device .tag-quick-vod{
  left: -19px;
  opacity: 1;
}

.section .link-privacy{
  display: block;
  position: relative;
  z-index: 30;
  padding: 40px 0;
  text-align: center;
}

.section .link-privacy span{
  font-size: 12px;
  line-height: 18px;
  color: #a5a5a5;
  text-decoration: underline;
}

/* animations: common */
.section .title,
.section .sub-title{
  position: relative;
  top: 40px;
  opacity: 0;
}

.section .title{
  -webkit-transition: top 0.8s ease-in-out 0.4s, opacity 1s ease-in-out 0.6s;
  -moz-transition: top 0.8s ease-in-out 0.4s, opacity 1s ease-in-out 0.6s;
  -o-transition: top 0.8s ease-in-out 0.4s, opacity 1s ease-in-out 0.6s;
  transition: top 0.8s ease-in-out 0.4s, opacity 1s ease-in-out 0.6s;
}

.section .sub-title{
  -webkit-transition: top 0.8s ease-in-out 0.6s, opacity 1s ease-in-out 0.8s;
  -moz-transition: top 0.8s ease-in-out 0.6s, opacity 1s ease-in-out 0.8s;
  -o-transition: top 0.8s ease-in-out 0.6s, opacity 1s ease-in-out 0.8s;
  transition: top 0.8s ease-in-out 0.6s, opacity 1s ease-in-out 0.8s;
}

.section.on .title,
.section.on .sub-title{
  top: 0;
  opacity: 1;
}

/* animations: section1 */
.section .btn-animation{
  position: relative;
  opacity: 0;
}

.section .btn-animation{
  -webkit-animation: btnAnimation 1s ease 1.2s 1 normal forwards;
  -moz-animation: btnAnimation 1s ease 1.2s 1 normal forwards;
  animation: btnAnimation 1s ease 1.2s 1 normal forwards;
}

@-webkit-keyframes btnAnimation {
  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
}

@-moz-keyframes btnAnimation {
  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
}

@keyframes btnAnimation {
  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
}

/* animations: section2 */
.section.on .coupon{
  top: 0;
  opacity: 1;
  -webkit-transition: top 1s ease-in-out 1.6s, opacity 1s ease-in-out 1.3s;
  -moz-transition: top 1s ease-in-out 1.6s, opacity 1s ease-in-out 1.3s;
  -o-transition: top 1s ease-in-out 1.6s, opacity 1s ease-in-out 1.3s;
  transition: top 1s ease-in-out 1.6s, opacity 1s ease-in-out 1.3s;
}

@-webkit-keyframes couponMotion{
  0% {
    top: 0;
  }
  25% {
    top: -10px;
  }
  75% {
    top: 20px;
  }
  100% {
    top: 0;
  }
}

@-moz-keyframes couponMotion{
  0% {
    top: 0;
  }
  25% {
    top: -10px;
  }
  75% {
    top: 20px;
  }
  100% {
    top: 0;
  }
}

@keyframes couponMotion{
  0% {
    top: 0;
  }
  25% {
    top: -10px;
  }
  75% {
    top: 20px;
  }
  100% {
    top: 0;
  }
}

.section.on .coupon img{
  -webkit-animation: couponMotion 1.6s linear 1.7s;
  -moz-animation: couponMotion 1.6s linear 1.7s;
  animation: couponMotion 1.6s linear 1.7s;
}

@-webkit-keyframes shadowMotion{
  0% {
    opacity: 1;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes shadowMotion{
  0% {
    opacity: 1;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes shadowMotion{
  0% {
    opacity: 1;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.section.on .coupon::after{
  -webkit-animation: shadowMotion 0.9s linear 2.1s;
  -moz-animation: shadowMotion 0.9s linear 2.1s;
  animation: shadowMotion 0.9s linear 2.1s;
}

.section.on .notice{
  opacity: 1;
  -webkit-transition: opacity 0.8s ease-in-out 2.8s;
  -moz-transition: opacity 0.8s ease-in-out 2.8s;
  -o-transition: opacity 0.8s ease-in-out 2.8s;
  transition: opacity 0.8s ease-in-out 2.8s;
}

/* animations: section3 */
#section3.on .content-area{
  opacity: 1;
}

/* animations: section4 */
.section.on .timer ol{
  -webkit-animation: timerAnimation 2s ease-in-out 1.5s 1 normal forwards;
  -moz-animation: timerAnimation 2s ease-in-out 1.5s 1 normal forwards;
  animation: timerAnimation 2s ease-in-out 1.5s 1 normal forwards;
}

@-webkit-keyframes timerAnimation {
  0%{
    top: -400%;
  }

  25%{
    top: -300%;
  }

  50%{
    top: -200%;
  }

  75%{
    top: -100%;
  }

  100%{
    top: 0;
  }
}

@-moz-keyframes timerAnimation {
  0%{
    top: -400%;
  }

  25%{
    top: -300%;
  }

  50%{
    top: -200%;
  }

  75%{
    top: -100%;
  }

  100%{
    top: 0;
  }
}

@keyframes timerAnimation {
  0%{
    top: -400%;
  }

  25%{
    top: -300%;
  }

  50%{
    top: -200%;
  }

  75%{
    top: -100%;
  }

  100%{
    top: 0;
  }
}

/* tablet */
@media (min-width: 768px) and (orientation: portrait), (min-width: 1024px) and (orientation: landscape) {
  /* common */
  .sub-title span{
    display: inline;
  }

  .notice{
    margin-top: 0;
  }

  /* section1 */
  #section1 .swiper-slide:nth-child(6n-4){
    margin-top: 180px;
  }

  #section1 .swiper-slide:nth-child(6n-3){
    margin-top: 60px;
  }

  #section1 .swiper-slide:nth-child(6n-2){
    margin-top: 135px;
  }

  #section1 .swiper-slide:nth-child(6n-1){
    margin-top: 45px;
  }

  #section1 .swiper-slide:nth-child(6n){
    margin-top: 105px;
  }

  /* section2 */
  .coupon{
    width: 370px;
    margin-top: 30px;
    padding: 30px 39px;
  }

  .coupon::after{
    height: 10px;
    margin-top: 20px;
  }

  .coupon + .notice{
    margin-top: 30px;
  }

  /* section3 */
  #section3 .content-area{
    background-size: 29% auto;
  }

  .content-text,
  #textFadeSwiper .swiper-pagination.swiper-pagination-bullets{
    width: 29%;
  }

  .btn-floating{
    width: 480px;
    left: 50%;
    right: auto;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
  }

  /* section4 */
  .quick-vod-area{
    height: 344px;
  }

  .device{
    width: 489px;
    height: 301px;
  }

  .section.on .device{
    width: 413px;
    height: 230px;
  }

  .viewport{
    top: 6px;
    right: 6px;
    bottom: 33px;
    left: 6px;
  }

  .section.on .viewport{
    bottom: 6px;
    -webkit-border-radius: 17px;
    -moz-border-radius: 17px;
    border-radius: 17px;
  }

  .device .tag-quick-vod{
    width: 160px;
    height: 46px;
    top: 20px;
  }

  .section.on .device .tag-quick-vod{
    left: -24px;
  }
}

/* high resolution */
@media screen and (min-width: 1024px) {
  #section3 .content-area{
    background-size: 25% auto;
  }

  .content-text,
  #textFadeSwiper .swiper-pagination.swiper-pagination-bullets{
    width: 25%;
  }
}

/* low resolution */
@media screen and (max-width: 374px) {
  #textFadeSwiper .swiper-pagination.swiper-pagination-bullets{
    width: 100%;
  }
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  border-left: 0;
  border-right: 0;
  border-top:0;
}

</style>
